import Industries from "./Industries.container";

export default Industries;
